import { motion } from "framer-motion";
import { scrollToId } from "./useCopy";

const LINKS = [
  ["lore", "Lore"],
  ["how-to-buy", "How to buy"],
  ["tokenomics", "Tokenomics"],
  ["roadmap", "Quarterly plan"],
];

export const Nav = () => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-teal-400/10 bg-[#07090e]/70 backdrop-blur-xl"
    data-testid="site-header"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
      <button onClick={() => scrollToId("top")} className="group flex items-center gap-3" data-testid="nav-logo">
        <img src="/img/logo.png" alt="Corporate Overlord logo" className="h-10 w-10 rounded-full ring-1 ring-amber-400/60 transition-transform duration-500 group-hover:rotate-[-8deg]" />
        <span className="font-display text-lg font-bold tracking-wider text-gold">OVERLORD</span>
      </button>
      <nav className="hidden items-center gap-8 md:flex">
        {LINKS.map(([id, label]) => (
          <button
            key={id}
            onClick={() => scrollToId(id)}
            data-testid={`nav-link-${id}`}
            className="font-mono text-xs uppercase tracking-[0.2em] text-slate-300 transition-colors hover:text-amber-300"
          >
            {label}
          </button>
        ))}
      </nav>
      <button
        onClick={() => scrollToId("how-to-buy")}
        data-testid="nav-buy-button"
        className="btn-gold clip-chip px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.2em]"
      >
        Buy $OVERLORD
      </button>
    </div>
  </motion.header>
);
